import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { cidadesService } from '../../services';
import { Cidade } from '../../types/pessoas';

const columns: ResourceColumn<Cidade>[] = [
  { header: 'Cidade', accessor: 'nome' },
  { header: 'IBGE', accessor: 'codigo_ibge' },
  { header: 'UF', render: (item) => item.uf_sigla ?? `ID ${item.uf}` },
];

export const CidadesListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ResourceListPage
      title="Cidades"
      description="Cadastro de cidades para vínculo em endereços."
      columns={columns}
      service={cidadesService}
      createPath="/admin/pessoas/cidades/novo"
      onEdit={(item) =>
        item.id && navigate('/admin/pessoas/cidades/editar', { state: { record: item } })
      }
      onDelete={(item) => (item.id ? cidadesService.remove(item.id) : Promise.resolve())}
    />
  );
};
